// Tissue Doppler Study
const TissueDopplerFields = ["TDI Medial Velocity", "TDI Lateral Velocity"];

export default TissueDopplerFields;
